// Mock data for BruhatYoga Swarna Ratnam sales funnel
// Replace success story shorts / telegram link with real values later.

export const product = {
  name: "BruhatYoga Swarna Ratnam",
  tagline: "Venus Energised Adrusta Ratnam",
  price: 13502,
  currency: "\u20b9",
  rating: 5.0,
  reviews: 5,
  image:
    "https://www.astrotalksadrustar.com/api/storage/objects/uploads/1ee33a27-55ea-43a4-86c8-8fffac6d40a0",
  badges: ["Venus Energised", "Lab Certified", "100% Natural", "Insured Delivery"],
  variant: "1 ct \u00b7 Silver \u00b7 Locket \u00b7 24k 4g",
  stock: 10,
  priceBreakdown: [
    { label: "Silver piece", value: "\u20b91" },
    { label: "Adrusta Ratnam", value: "\u20b913,500" },
    { label: "Pooja energisation", value: "\u20b91" },
  ],
  howToWear:
    "Wear around the neck as a locket, with the Adrusta Ratnam positioned against the chest and touching the skin.",
};

// Purchase options — standard and the premium higher-carat add-on for faster results.
export const variants = [
  {
    id: "standard",
    label: "Standard Adrusta Ratnam",
    spec: "8 ct \u00b7 Silver Locket \u00b7 Venus Energised",
    price: 13502,
    badge: "Most Chosen",
    highlight: false,
    perks: ["Lab certified & 100% natural", "Free energisation & certificate", "Insured delivery"],
  },
  {
    id: "premium",
    label: "Premium Higher-Carat Ratnam",
    spec: "Higher Carat Weight \u00b7 Stronger & Faster Results",
    price: 24300,
    badge: "Fastest Results",
    highlight: true,
    perks: [
      "Bigger, higher-carat energised stone",
      "Stronger vibration for quicker wealth results",
      "Priority pooja by Dr. Rama Yogi Lal Ji",
      "Free energisation, certificate & insured delivery",
    ],
  },
];

// Financial problems the BruhatYoga Swarna Ratnam is energised to help resolve.
export const financialProblems = [
  { icon: "Wallet", text: "No matter how much I earn, why is there never enough money left at the end of the month?" },
  { icon: "CreditCard", text: "When will I finally be free from EMIs, personal loans, and credit card debts?" },
  { icon: "TrendingDown", text: "Why is my income stuck at the same level while my expenses keep increasing?" },
  { icon: "Briefcase", text: "Why am I working so hard in my business but not seeing the profits I deserve?" },
  { icon: "PiggyBank", text: "Why am I unable to save enough money or build a secure financial future?" },
  { icon: "ShieldAlert", text: "What will happen if a medical emergency, job loss, or sudden expense hits my family?" },
  { icon: "GraduationCap", text: "Will I have enough money to give my children the education and lifestyle they deserve?" },
  { icon: "Home", text: "Will I ever be able to own a house, land, or property of my own?" },
  { icon: "Users", text: "How will I manage my parents\u2019 needs, my children\u2019s expenses, and my family\u2019s dreams?" },
  { icon: "Lock", text: "Will I ever become financially independent and stop worrying about money every day?" },
];

export const heroImages = {
  necklace:
    "https://images.unsplash.com/photo-1610375461369-d613b564f4c4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwxfHxnb2xkJTIwcHJvc3Blcml0eXxlbnwwfHx8fDE3OTAzMTQ3Mjd8MA&ixlib=rb-4.1.0&q=85",
  gem1:
    "https://images.unsplash.com/photo-1600862754152-80a263dd564f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwzfHxnZW1zdG9uZSUyMGpld2VsbGVyeXxlbnwwfHx8fDE3OTAzMTQ3Mjd8MA&ixlib=rb-4.1.0&q=85",
  gem2:
    "https://images.unsplash.com/photo-1592317295760-5c1f677dfc78?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwxfHxnZW1zdG9uZSUyMGpld2VsbGVyeXxlbnwwfHx8fDE3OTAzMTQ3Mjd8MA&ixlib=rb-4.1.0&q=85",
  gem3:
    "https://images.unsplash.com/photo-1617191880362-aac615de3c26?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHw0fHxnZW1zdG9uZSUyMGpld2VsbGVyeXxlbnwwfHx8fDE3OTAzMTQ3Mjd8MA&ixlib=rb-4.1.0&q=85",
  puja1:
    "https://images.unsplash.com/photo-1577083753695-e010191bacb5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwyfHxwdWphJTIwZGl5YXxlbnwwfHx8fDE3OTAzMTQ3Mjd8MA&ixlib=rb-4.1.0&q=85",
  puja2:
    "https://images.pexels.com/photos/12936912/pexels-photo-12936912.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  puja3:
    "https://images.unsplash.com/photo-1605292356183-a77d0a9c9d1d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwxfHxwdWphJTIwZGl5YXxlbnwwfHx8fDE3OTAzMTQ3Mjd8MA&ixlib=rb-4.1.0&q=85",
};

// Main explainer video (YouTube)
export const mainVideoId = "3cTApzuM74I";

export const astrologer = {
  name: "Dr. Maharshi Ramana Yogi Lal Ji",
  title: "Professional Astro Gemologist",
  bio: "A world-renowned ancient Vedic astrologer and Sarva-Mantra Upasak Pandit, expert across all branches of Astro gemology, numerology, palmistry and vastu. Trusted by lakhs of families on their journey to prosperity.",
};

export const store = {
  name: "ADRUSTAR RATNALAYAM",
  address:
    "Plot no 74B, Srinivasa Nagar Colony, A.S Rao Nagar, Kapra, Hyderabad - 500062",
  phone: "9399993389",
  whatsapp: "919399993389",
  mapLink: "https://maps.app.goo.gl/tUJ6FFwopSHcqBsf9",
};

export const whatYouGet = [
  {
    title: "Secret Mantra Guidance",
    desc: "Personal guidance on powerful mantras to incorporate into your daily spiritual practice.",
  },
  {
    title: "Beeja Akshara Guidance",
    desc: "How to practice and integrate sacred Beeja Aksharas into your spiritual routine.",
  },
  {
    title: "Right Wearing Guidance",
    desc: "When and how to wear the Ratnam, with recommended practices to follow.",
  },
  {
    title: "Daily Wealth Sadhana",
    desc: "A simple spiritual routine that can be practiced for a few minutes every day.",
  },
  {
    title: "Personal Wealth Sankalpam",
    desc: "A special process to define your wealth goals and set a personal Sankalpam towards them.",
  },
];

export const trustBadges = [
  { title: "Lab Certified", desc: "Certified for natural origin, cut & clarity" },
  { title: "Venus Energised", desc: "Pran Pratishtha by Vedic pandits" },
  { title: "100% Natural", desc: "Authentic natural Adrusta Ratnam" },
  { title: "Insured Delivery", desc: "Safe, insured shipping to your door" },
];

// Up to 5 YouTube Shorts for the Success Stories section.
// Replace these videoId values with your real Shorts IDs.
export const successStories = [
  { id: "PQW4tU6O1q4", name: "Ravi Kumar", place: "Hyderabad" },
  { id: "8Zq6oe7EBsg", name: "Lakshmi Devi", place: "Vijayawada" },
  { id: "XV4QM2wclck", name: "Suresh Babu", place: "Bengaluru" },
  { id: "usSyQeKa4pY", name: "Anitha Reddy", place: "Chennai" },
  { id: "OyaM-Zie2Tg", name: "Mahesh Rao", place: "Warangal" },
];

export const testimonials = [
  {
    name: "Srinivas R.",
    place: "Hyderabad",
    text: "Within weeks of wearing my Adrusta Ratnam, opportunities I had waited years for finally opened up. Truly blessed.",
  },
  {
    name: "Padma K.",
    place: "Vijayawada",
    text: "The guidance and the energised ratnam changed my mindset and my finances. My family is grateful to Guruji.",
  },
  {
    name: "Venkat M.",
    place: "Bengaluru",
    text: "Genuine, certified and powerful. The daily sadhana keeps me focused on my wealth goals every single day.",
  },
];

export const faqs = [
  {
    q: "Who can wear the Adrusta Ratnam?",
    a: "Anyone seeking prosperity, growth and abundance can wear it. Our guidance ensures it is energised and worn correctly for your intentions.",
  },
  {
    q: "Is the Ratnam certified and natural?",
    a: "Yes. Every Adrusta Ratnam is lab-certified for natural origin, cut and clarity. Your certificate ships with the piece and is registered to your order reference.",
  },
  {
    q: "How is it energised?",
    a: "Each ratnam undergoes Pran Pratishtha and Venus energisation by our Vedic pandits before it reaches you \u2014 completely free with your order.",
  },
  {
    q: "How do I wear it?",
    a: "Wear it around the neck as a locket, with the Adrusta Ratnam positioned against the chest and touching the skin. Full guidance is provided.",
  },
  {
    q: "Is delivery safe?",
    a: "Yes, every order is insured and shipped safely to your doorstep along with the certificate of authenticity.",
  },
];

export const telegramLink = "https://t.me/adrustaratnam";
